import { TreeNode } from 'primereact/treenode'
import { TreeCheckboxSelectionKeys } from 'primereact/tree'
import DirectoryEntry from '../models/DirectoryEntry'
import { StructureTypes } from '../models/Structure'

export const SERVICE_INTERVALS = [30, 90, 180, 270]
export const MAX_SERVICE_CONNECTIONS = 500

// A folder selection is a snapshot of its current, non-archived bolt connections.
export function serviceSelectionNodes(entries: DirectoryEntry[]): TreeNode[] {
    return entries
        .filter((entry) => !entry.isArchived)
        .flatMap((entry) => {
            const children = serviceSelectionNodes(entry.children)
            const bolt = entry.referenceType === StructureTypes.BoltConnection
            if (!bolt && children.length === 0) return []
            return [
                {
                    key: entry.id,
                    label: entry.name,
                    data: entry,
                    icon: bolt ? 'pi pi-box' : 'pi pi-folder',
                    children,
                    leaf: bolt,
                },
            ]
        })
}

export function serviceSelectionKeys(nodes: TreeNode[], ids: string[]): TreeCheckboxSelectionKeys {
    const selected = new Set(ids)
    const keys: TreeCheckboxSelectionKeys = {}
    const visit = (node: TreeNode): boolean => {
        const children = node.children ?? []
        const results = children.map(visit)
        const checked = node.leaf ? selected.has(String(node.key)) : results.every(Boolean)
        const partialChecked =
            !checked &&
            children.some((child) => {
                const state = keys[String(child.key)]
                return state?.checked || state?.partialChecked
            })
        if (checked || partialChecked) keys[String(node.key)] = { checked, partialChecked }
        return checked
    }
    nodes.forEach(visit)
    return keys
}

export function selectedServiceBoltIds(
    nodes: TreeNode[],
    keys: TreeCheckboxSelectionKeys
): string[] {
    return nodes.flatMap((node) =>
        node.leaf
            ? keys[String(node.key)]?.checked
                ? [String(node.key)]
                : []
            : selectedServiceBoltIds(node.children ?? [], keys)
    )
}

export function validServiceDates(start?: Date | null, end?: Date | null) {
    return (
        !!start &&
        !!end &&
        Number.isFinite(start.getTime()) &&
        Number.isFinite(end.getTime()) &&
        end >= start
    )
}
